module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Home\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "welcome text-center"
  }, [_c('header', {
    staticClass: "welcome-header"
  }, [_c('h3', {
    staticClass: "welcome-title"
  }, [_vm._v("Welcome to your financial advisor portal "), _c('br'), _vm._v("at Calvert Impact Capital")])]), _vm._v(" "), _c('p', {
    staticClass: "welcome-paragraph"
  }, [_vm._v("\n               We invite you to learn "), _c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener",
      "aria-describedby": "new-window-0",
      "href": "https://www.calvertimpactcapital.org/about"
    }
  }, [_vm._v("about our work "), _c('em', {
    staticClass: "fa fa fa-external-link"
  })]), _vm._v(".\n               "), _c('br'), _vm._v("Or proceed to manage your clients' accounts.\n            ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row tutorial-row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "tutorial"
  }, [_c('header', {
    staticClass: "tutorial-header"
  }, [_c('h3', {
    staticClass: "tutorial-title"
  }, [_vm._v("How to access your client's accounts")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "tutorial-step"
  }, [_c('div', {
    staticClass: "image-holder"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/tutorial_1.png"),
      "alt": "step-1"
    }
  })]), _vm._v(" "), _c('ol', [_c('li', [_c('strong', [_vm._v("Click on your name at the top right of the page.")]), _vm._v(" "), _c('p', [_vm._v("A dropdown with links to your account and your clients' accounts will be shown.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tutorial-step"
  }, [_c('div', {
    staticClass: "image-holder"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/tutorial_2.png"),
      "alt": "step-2"
    }
  })]), _vm._v(" "), _c('ol', {
    attrs: {
      "start": "2",
      "id": "step-2"
    }
  }, [_c('li', [_c('strong', [_vm._v("Once you see the dropdown, click on one of your clients' accounts.")]), _vm._v(" "), _c('p', [_vm._v("Switch between client accounts from the dropdown.")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6500557e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 2162
// module chunks = 1